<template>
  <account-modal class="add-account-number-modal">
    <template slot="heading">Add IBAN</template>

    <template slot="content">
      <v-checkbox
        v-model="form.autoIban"
        :ripple="false"
        label="AUTO generate IBAN"
        color="primary"
        hide-details
        @change="onAutoGenerateIban()"
      />
      <v-text-field
        v-if="!form.autoIban"
        id="account-number-number"
        v-model="form.accountNumber"
        label="IBAN"
        hint="Required field"
        persistent-hint
        :error-messages="getValidationErrorMessage('accountNumber')"
      />

      <v-select
        id="account-number-channel"
        v-model="form.channel"
        :items="channelOptions"
        item-text="name"
        item-value="value"
        label="Channel"
        hint="Required field"
        persistent-hint
        :error-messages="getValidationErrorMessage('channel')"
      />

      <v-autocomplete
        id="currency"
        v-model="form.currencies"
        :items="currencyOptions"
        item-text="name"
        item-value="value"
        placeholder="Currencies"
        multiple
        :error-messages="getValidationErrorMessage('currencies')"
      />

      <error-alert :error="error" />
    </template>

    <template slot="actions">
      <v-btn
        id="add-account-number"
        color="light-blue darken-3"
        flat
        :disabled="!isFormFilled || loading"
        @click="onSaveButtonClick"
      >save</v-btn>

      <v-btn
        class="t-close-modal"
        color="light-blue darken-3"
        flat
        @click="onCancelButtonClick"
      >cancel</v-btn>
    </template>
  </account-modal>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  // Events
  import { EVENT_ACCOUNT_UPDATE } from '@/events/accounts'

  // Services
  import ApiRequest from '@/services/ApiRequests/ApiRequest'
  import AccountApi from '@/services/Api/AccountApi'

  // Models
  import Payment from '@/models/Payment'

  // Mixins
  import form from '@/mixins/form'

  // Component
  import AccountModal from '@/components/accounts/AccountModal'
  import ErrorAlert from '@/components/ui/ErrorAlert'
  import currencies from 'assets/data/currencies.json'

  export default {
    name: 'AddAccountNumberModal',
    components: {
      AccountModal,
      ErrorAlert
    },
    mixins: [form],
    data () {
      return {
        accountNumberAddApiRequest: new ApiRequest(AccountApi.addAccountNumber),
        form: {
          autoIban: false,
          accountNumber: null,
          channel: null,
          currencies: null
        }
      }
    },
    requiredFields () {
      const requiredFields = [
        'channel'
      ]

      if (!this.form.autoIban) {
        requiredFields.push('accountNumber')
      }

      return requiredFields
    },
    computed: {
      ...mapGetters('modal', ['modal']),
      profileId () {
        return this.modal.data.profileId
      },
      account () {
        return this.modal.data.account
      },
      channelOptions () {
        return Payment.channelOptions
      },
      loading () {
        return this.accountNumberAddApiRequest.loading
      },
      error () {
        return this.accountNumberAddApiRequest.error
      },
      currencyOptions () {
        return currencies.map(currency => ({
          name: currency,
          value: currency
        }))
      }
    },
    methods: {
      ...mapActions('modal', ['showModal', 'closeModal']),
      onSaveButtonClick () {
        this.accountNumberAddApiRequest
          .execute(this.account.accountId, this.form)
          .then(this.accountNumberAddSuccessHandler)
          .catch(() => {})
      },
      onCancelButtonClick () {
        this.closeModal()
      },
      onAutoGenerateIban () {
        if (this.form.autoIban) {
          this.form.accountNumber = null
        }
      },
      accountNumberAddSuccessHandler () {
        this.$eventHub.$emit(EVENT_ACCOUNT_UPDATE, this.profileId)
        this.closeModal()

        setTimeout(() => {
          this.showModal({
            name: 'SuccessFlashModal',
            data: { message: 'Account number has been successfully added.' }
          })
        }, 100)
      }
    }
  }
</script>
